import axios from 'axios';

export const VoucherAppointmentsApi = {
  getAppointments: filter =>
    axios.get(`/api/self/paging/kindergarten_voucher?filter=${filter}`),
  prolongVoucher: data =>
    axios.post(`/api/public/transitions/kindergarten_voucher/prolong`, data),
  getSignForDeclineVoucher: data =>
    axios.post(
      `/api/public/transitions/info/sign_string/kindergarten_voucher_decline`,
      data
    ),
  declineVoucher: data =>
    axios.put(`/api/public/transitions/kindergarten_voucher/decline`, data),
  appointmentDownload: requestFormId =>
    axios.get(
      `/api/public/info/request_form_preview/${requestFormId}/voucher?force=true`,
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/csv'
        }
      }
    ),
  getSignString: data =>
    axios.post(
      '/api/public/transitions/info/sign_string/kindergarten_voucher',
      data
    ),

  reservePlace: data =>
    axios.post(
      `/api/public/transitions/kindergarten_voucher/reserve_place`,
      data
    ),

  getAppointmentsSC: filter =>
    axios.get(`/api/self/paging/universal_voucher?filter=${filter}`),
  getSignStringReservePlaceSC: data =>
    axios.post(
      '/api/public/transitions/info/sign_string/universal_voucher',
      data
    ),
  reservePlaceSC: data =>
    axios.post(
      `/api/public/transitions/universal_voucher/reserve_place`,
      data
    ),
  declineVoucherSC: data =>
    axios.put(`/api/public/transitions/universal_voucher/decline`, data),
  getSignForDeclineVoucherSC: data =>
    axios.post(
      `/api/public/transitions/info/sign_string/universal_voucher_decline`,
      data
    ),
  prolongVoucherSC: data =>
    axios.post(`/api/public/transitions/universal_voucher/prolong`, data),
  appointmentDownloadSC: requestFormId =>
    axios.get(
      `/api/public/info/request_form_preview/${requestFormId}/voucher?force=true`,
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/csv'
        }
      }
    ),
};
